module.exports = __webpack_public_path__ + "static/media/LineVerticalGreenColor.53d48989.svg";